import React from 'react';

import PropTypes from 'prop-types';

import DrawerContent from './DrawerContent';
import { getDrawerSizeInPX } from './helpers';
import StyledDrawer from './StyledComponents/StyledDrawer';

const SideBar = ({
    drawerSize,
    handleDrawerToggle,
    match,
    mobileOpen,
    setMobileOpen,
    setSidebarOpen,
    sidebarOpen,
    toggleDrawerSize,
}) => {
    const container =
        window !== undefined ? () => window.document.body : undefined;

    const onMouseEnter = () => {
        if (drawerSize === 'small') {
            setSidebarOpen(true);
            return;
        }
        setSidebarOpen(false);
    };

    const onMouseLeave = () => {
        if (drawerSize === 'small') {
            setSidebarOpen(false);
        }
    };

    const sx = {
        display: { md: 'block', xs: 'none' },
        '& .MuiDrawer-paper': {
            width: sidebarOpen
                ? getDrawerSizeInPX('normal')
                : getDrawerSizeInPX(drawerSize),
            overflowX: 'hidden',
        },
    };

    const sxTemporaryDrawer = {
        display: { md: 'none', xs: 'block' },
        '& .MuiDrawer-paper': {
            boxSizing: 'border-box',
            width: '100%',
        },
    };
    const drawerContent = (
        <DrawerContent
            container={container}
            drawerSize={sidebarOpen ? 'normal' : drawerSize}
            handleDrawerToggle={handleDrawerToggle}
            match={match}
            mobileOpen={mobileOpen}
            setSidebarOpen={setSidebarOpen}
            setMobileOpen={setMobileOpen}
            sidebarOpen={sidebarOpen}
            toggleDrawerSize={toggleDrawerSize}
        />
    );
    return (
        <React.Fragment>
            <StyledDrawer
                drawersize={drawerSize}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                variant="permanent"
                sx={sx}
            >
                {drawerContent}
            </StyledDrawer>

            <StyledDrawer
                container={container}
                drawersize={drawerSize}
                ModalProps={{ keepMounted: true }}
                open={mobileOpen}
                onClose={handleDrawerToggle}
                variant="temporary"
                sx={sxTemporaryDrawer}
            >
                {drawerContent}
            </StyledDrawer>
        </React.Fragment>
    );
};

SideBar.propTypes = {
    drawerSize: PropTypes.string,
    handleDrawerToggle: PropTypes.func,
    match: PropTypes.object,
    mobileOpen: PropTypes.bool,
    setMobileOpen: PropTypes.func,
    setSidebarOpen: PropTypes.func,
    sidebarOpen: PropTypes.bool,
    toggleDrawerSize: PropTypes.func,
};

export default SideBar;
